
import React from "react";

import '../styles.scss';
import './section2.scss';
import CarouselComponent from "./carouselComponent.tsx";

/**
     * section 2
     * text
     * card layout
     * single line text
     * carousel
     */
const Section2: React.FC = () => {


    return (
        <section className="container padBox bg-light">

            <p className="py-5 font_nun_reg p3 lh-sm fw-bold">
                
                Dhyana, meaning <b>&#8220;meditation&#8221; </b> in Sanskrit, merges ancient Indian wisdom with modern technology to create
                 immersive relaxation therapies. Its mission is to calm the mind, relax
                  the body, and foster healing, guiding individuals toward holistic well-being.
            </p>
            <div className="clearfix"></div>
            <div className="my-4">
                
                <div className="card mb-3 bg-light" >
                    <div className="row g-0">
                        <div className="col-md-4">
                            {/* <img src="./assets/images/BBNight.jpg" className="img-fluid rounded-start" alt="" /> */}
                            <video
                                id="video_2"
                                preload="auto"
                                autoPlay
                                controlsList="nodownload"
                                muted
                                playsInline 
                                loop
                                poster="./assets/videos/Nightsky.jpg"
                                className="img-fluid rounded-start"
                            >
                                <source src="./assets/videos/Nightsky.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                {/* <h5 className="card-title">Card title</h5>
                                <p className="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p> */}

                                {/* <p className="card-text ps-1 lh-sm fw-bold">
                                Dhyana combines ancient Indian therapeutic wisdom with cutting-edge VR technology to offer transformative healing. 
                                Through immersive environments and techniques like box breathing, Dhyana engages the mind to relieve stress and support recovery. Blending tradition with innovation, it creates a sanctuary for patients to find relief and focus on their well-being.
                                </p> */}

                                <p className="card-text font_nun_reg  lh-sm fw-bold d-flex-sm-wrap">
                                Dhyana combines ancient Indian therapeutic wisdom with cutting-edge VR technology to offer transformative healing. 
                                <span className="flex-basis-sm-100">Through immersive environments and techniques like box breathing, Dhyana engages the mind to relieve stress and support recovery. </span>
                                <span className="flex-basis-sm-100">Blending tradition with innovation, it creates a sanctuary for patients to find relief and focus on their well-being.</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix"></div>
            <p className="font_nun_reg p1_1 mb-3 mt-5 fw-bold d-flex-sm-wrap">Healing Through Innovation |<span className="greend_50 flex-basis-sm-100"> when the mind is calm, the body follows.</span>  </p>
            <div className="clearfix"></div>

            <CarouselComponent />
            <div className="clearfix"></div>

            <hr className="half_line my-5 " />

            <div className="clearfix"></div>


        </section>
    );
}


export default Section2;
